/* ===== Element references ===== */
const fileInput = document.getElementById('profile-picture');
const uploadArea = document.getElementById('upload-area');
const uploadPreview = document.getElementById('upload-preview');
const previewImage = document.getElementById('preview-image');
const changePhotoBtn = document.getElementById('change-photo-btn');
const removePhotoBtn = document.getElementById('remove-photo-btn');
const croppedDataInput = document.getElementById('profile-photo');

/* Crop modal elements */
const cropModal = document.getElementById('crop-modal');
const cropModalOverlay = document.getElementById('crop-modal-overlay');
const cropImage = document.getElementById('crop-image');
const cropConfirmBtn = document.getElementById('crop-confirm-btn');
const cropCancelBtn = document.getElementById('crop-cancel-btn');
const cropCancelBtn2 = document.getElementById('crop-cancel-btn-2');

let cropper = null;
let enforcingMin = false;

/**
 * Holds the cropped image File so it can be appended to FormData at
 * submit time instead of sending a massive base64 string.
 */
window.__croppedProfileFile = null;

/* ===== Open the crop modal ===== */
function openCropModal(imageSrc) {
  cropImage.src = imageSrc;
  cropModal.classList.add('is-active');
  document.body.style.overflow = 'hidden';

  /* Wait for image to load before initialising Cropper */
  cropImage.onload = function () {
    if (cropper) {
      cropper.destroy();
    }
    cropper = new Cropper(cropImage, {
      aspectRatio: 1,
      viewMode: 1,
      dragMode: 'move',
      autoCropArea: 1,
      cropBoxResizable: true,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: false,
      minCropBoxWidth: 50,
      minCropBoxHeight: 50,
      responsive: true,
      crop: function (event) {
        if (enforcingMin) return;
        var data = event.detail;
        if (data.width < 400 || data.height < 400) {
          enforcingMin = true;
          cropper.setData({
            width: Math.max(data.width, 400),
            height: Math.max(data.height, 400),
          });
          enforcingMin = false;
        }
      },
    });
  };
}

/* ===== Close the crop modal ===== */
function closeCropModal() {
  cropModal.classList.remove('is-active');
  document.body.style.overflow = '';
  if (cropper) {
    cropper.destroy();
    cropper = null;
  }
  /* Reset the file input so the same file can be re-selected */
  fileInput.value = '';
}

/* ===== Show cropped preview ===== */
function showPreview(objectURL) {
  previewImage.src = objectURL;
  /* Set a simple flag value so validation knows a photo has been chosen.
     The actual file is stored in window.__croppedProfileFile. */
  croppedDataInput.value = 'cropped';
  uploadArea.style.display = 'none';
  uploadPreview.style.display = '';
}

/* ===== Reset to upload state ===== */
function resetUpload() {
  /* Revoke any existing object URL to free memory */
  if (previewImage.src && previewImage.src.startsWith('blob:')) {
    URL.revokeObjectURL(previewImage.src);
  }
  previewImage.src = '';
  croppedDataInput.value = '';
  fileInput.value = '';
  window.__croppedProfileFile = null;
  uploadArea.style.display = '';
  uploadPreview.style.display = 'none';
}

/* ===== Event: file selected ===== */
fileInput.addEventListener('change', function (e) {
  var file = e.target.files && e.target.files[0];
  if (!file) return;

  /* Validate type */
  if (!file.type.match(/^image\/(jpeg|png)$/)) {
    alert('Please select a JPEG or PNG image.');
    fileInput.value = '';
    return;
  }

  /* Validate size (50 MB) */
  if (file.size > 50 * 1024 * 1024) {
    alert('File size must be under 50 MB.');
    fileInput.value = '';
    return;
  }

  var reader = new FileReader();
  reader.onload = function (ev) {
    var dataURL = ev.target.result;

    /* Validate minimum dimensions (400×400) */
    var testImg = new Image();
    testImg.onload = function () {
      if (testImg.naturalWidth < 400 || testImg.naturalHeight < 400) {
        alert(
          'Image must be at least 400×400 pixels. Your image is ' +
            testImg.naturalWidth +
            '×' +
            testImg.naturalHeight +
            '.',
        );
        fileInput.value = '';
        return;
      }
      openCropModal(dataURL);
    };
    testImg.src = dataURL;
  };
  reader.readAsDataURL(file);
});

/* ===== Event: confirm crop ===== */
cropConfirmBtn.addEventListener('click', function () {
  if (!cropper) return;

  var canvas = cropper.getCroppedCanvas({
    width: 500,
    height: 500,
    imageSmoothingEnabled: true,
    imageSmoothingQuality: 'high',
  });

  if (canvas) {
    canvas.toBlob(function (blob) {
      if (!blob) return;

      /* Wrap the Blob in a File so it carries a proper filename */
      var croppedFile = new File([blob], 'profile-photo.png', { type: 'image/png' });
      window.__croppedProfileFile = croppedFile;

      /* Create an object URL for the preview image */
      var objectURL = URL.createObjectURL(blob);
      showPreview(objectURL);
    }, 'image/png');
  }

  closeCropModal();
});

/* ===== Event: cancel crop ===== */
cropCancelBtn.addEventListener('click', closeCropModal);
cropCancelBtn2.addEventListener('click', closeCropModal);
cropModalOverlay.addEventListener('click', closeCropModal);

/* ===== Event: change photo ===== */
changePhotoBtn.addEventListener('click', function () {
  fileInput.click();
});

/* ===== Event: remove photo ===== */
removePhotoBtn.addEventListener('click', resetUpload);

/* ===== Close modal on Escape key ===== */
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && cropModal.classList.contains('is-active')) {
    closeCropModal();
  }
});
